import script from "./agentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./agentEdit.vue?vue&type=script&setup=true&lang=js"

import "./agentEdit.vue?vue&type=style&index=0&id=263ba816&scoped=true&lang=css"

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\力氧空间-天康疗养中心\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263ba816"]])

export default __exports__